/*
 * Cartes produits : pastille « 3D » = ajouter le produit à ma sélection du Logiciel 3D (2026-10-17)
 * - Affichée seulement sur les produits posables dans le logiciel (liste window.EM_PLAN3D, em-plan3d-data.js).
 * - Le produit est ajouté aux favoris du logiciel (localStorage emch2-favs, même site) :
 *   le client le retrouve dans « Mes favoris » en ouvrant le Logiciel 3D ; synchronisé avec son compte.
 */
(function () {
  var FAV = 'emch2-favs';
  var PLANNER = '/pages/planificateur-3d';
  var map = null;
  function getMap() {
    if (map) return map;
    map = new Map();
    (window.EM_PLAN3D || []).forEach(function (x) { map.set(String(x[0]), x[1]); });
    return map;
  }
  function favs() { try { var a = JSON.parse(localStorage.getItem(FAV) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function saveFavs(a) { try { localStorage.setItem(FAV, JSON.stringify(a)); } catch (e) {} }

  var ICON = '<svg viewBox="0 0 256 256" width="16" height="16" fill="currentColor" aria-hidden="true"><path d="M223.68,66.15,135.68,18a15.88,15.88,0,0,0-15.36,0l-88,48.17a16,16,0,0,0-8.32,14v95.64a16,16,0,0,0,8.32,14l88,48.17a15.88,15.88,0,0,0,15.36,0l88-48.17a16,16,0,0,0,8.32-14V80.18A16,16,0,0,0,223.68,66.15ZM128,32l80.34,44L128,120,47.66,76ZM40,90l80,43.78v85.79L40,175.82Zm96,129.57V133.82L216,90v85.78Z"/></svg>';

  function decorate(root) {
    var m = getMap();
    if (!m.size) return;
    var f = favs();
    (root || document).querySelectorAll('.em-coll-card[data-product-id]:not([data-em-3d])').forEach(function (card) {
      card.setAttribute('data-em-3d', '');
      var v = m.get(card.dataset.productId);
      if (!v) return;
      var media = card.querySelector('.em-coll-card__media');
      if (!media) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'em-3d-btn' + (f.indexOf(v) !== -1 ? ' is-in' : '');
      b.setAttribute('data-em-3d-add', String(v));
      b.setAttribute('aria-label', 'Ajouter à ma sélection 3D');
      b.innerHTML = ICON + '<span>3D</span><em class="em-3d-tip">' + (f.indexOf(v) !== -1 ? 'Ajouté à votre plan 3D' : 'Ajouter à mon plan 3D') + '</em>';
      media.appendChild(b);
    });
  }

  // Fiche produit : bouton « Ajouter à mon plan 3D » à côté de wishlist et devis (2026-10-19)
  function decoratePdp() {
    var m = getMap();
    document.querySelectorAll('[data-em-pdp-3d]:not([data-em-3d-add])').forEach(function (b) {
      var v = m.get(b.dataset.productId);
      if (!v) return;
      b.setAttribute('data-em-3d-add', String(v));
      b.hidden = false;
      if (favs().indexOf(v) !== -1) { b.classList.add('is-in'); b.querySelector('span').textContent = 'Ajouté à mon plan 3D'; }
    });
  }

  function toast(html) {
    var t = document.querySelector('.em-coll-toast');
    if (!t) { t = document.createElement('div'); t.className = 'em-coll-toast'; document.body.appendChild(t); }
    t.innerHTML = html;
    t.classList.remove('em-coll-toast--show'); void t.offsetWidth; t.classList.add('em-coll-toast--show');
    clearTimeout(t._tmr); t._tmr = setTimeout(function () { t.classList.remove('em-coll-toast--show'); }, 4200);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-em-3d-add]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var v = +b.getAttribute('data-em-3d-add');
    var card = b.closest('.em-coll-card');
    if (b.hasAttribute('data-em-pdp-3d')) { var sp = b.querySelector('span'); if (sp) sp.textContent = 'Ajouté à mon plan 3D'; }
    var title = card ? card.dataset.title : 'Le produit';
    var f = favs();
    if (f.indexOf(v) === -1) { f.unshift(v); saveFavs(f.slice(0, 500)); }
    // file d'attente : posé automatiquement dans le plan à l'ouverture du Logiciel 3D
    try { var q = JSON.parse(localStorage.getItem('emch2-ajout') || '[]'); if (!Array.isArray(q)) q = []; if (q.indexOf(v) === -1) q.push(v); localStorage.setItem('emch2-ajout', JSON.stringify(q.slice(-50))); } catch (err) {}
    b.classList.add('is-in', 'is-pop');
    var tip = b.querySelector('.em-3d-tip'); if (tip) tip.textContent = 'Ajouté à votre plan 3D';
    setTimeout(function () { b.classList.remove('is-pop'); }, 500);
    toast('<span style="white-space:nowrap">🧊 Ajouté à votre plan 3D</span> <a href="' + PLANNER + '" target="_blank" rel="noopener" style="white-space:nowrap">Ouvrir le Logiciel 3D →</a>');
  }, true);

  function init() {
    decoratePdp();
    decorate();
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { decorate(); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
